import { useQuery } from '@tanstack/react-query';

import { CloudForwarderForwarders } from '@graylog/enterprise-api';

import { defaultOnError } from 'util/conditional/onError';

const FORWARDERS_CONFIGURATION_QUERY_KEY = 'forwarders_configuration_hostname';

type Data = {
  server_hostname?: string;
  grpc_enable_tls?: boolean;
  forwarder_service_autostart?: boolean;
};

const DEFAULT_DATA = {};

const getConfiguration = async (): Promise<Data> => CloudForwarderForwarders.getConfiguration() as Promise<Data>;

const useForwardersConfiguration = (): {
  data: Data;
  isLoading: boolean;
} => {
  const { data: responseData, isLoading } = useQuery({
    queryKey: [FORWARDERS_CONFIGURATION_QUERY_KEY],
    queryFn: () =>
      defaultOnError(
        getConfiguration(),
        `Loading Forwarders configuration failed with status`,
        `Could not load Forwarders configuration`,
      ),
  });

  return {
    data: responseData ?? DEFAULT_DATA,
    isLoading,
  };
};

export default useForwardersConfiguration;
